var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"one-tab",class:{ active: _vm.isActive },on:{"click":_vm.selectTab}},[(_vm.icon)?_c('div',{staticClass:"one-tab__icon"},[_c('i',{class:_vm.iconClass})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"one-tab__label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }